<template>
  <div>
    <PageTitle
      title="Tables"
      :btnCreate="true"
      :createPopup="true"
      @onClickCreate="OpenModal()"
      :permission="'Table Create'"
    />
    <v-container fluid class="lighten-12 content">
      <v-card class="lighten-12 card-content mb-2">
        <v-row class="ma-0 align-right">
          <TableFilters
            :filters="['status', 'search']"
            v-model="filter"
            :columns="columns"
          ></TableFilters>
          <ImportExportMenu :permission="'Category Report'"></ImportExportMenu>
        </v-row>
      </v-card>
      <v-card class="lighten-12 card-content mt-0 pa-3">
        <v-col
          class="pr-1 text-right"
          cols="12"
          xs="12"
          sm="6"
          md="2"
          lg="2"
          xl="2"
        >
         
        </v-col>
        <v-progress-linear
          active="false"
          indeterminate="false"
          :query="false"
          v-if="isLoading"
        ></v-progress-linear>
        <v-data-table
          :fixed-header="true"
          :headers="headers"
          :items-per-page="paginationOptions.perPage"
          :items="ProductCategory"
        
          item-key="id"
          hide-default-footer
        >
          <template v-slot:no-data>
            <!-- <img
              style="height: 200px;"
              src="../../../../../assets/img/no-result.jpg"
            /> -->
          </template>
          <!-- No -->
          <template v-slot:item.no>
            <v-icon>mdi-vuetify</v-icon>
          </template>

          <!-- Status -->
          <template v-slot:item.is_active="{ item }" :slot-scope="props">
            <v-chip
              :x-small="true"
              class="ma-2"
              label
              text-color="white"
              :color="getStatusColor(item.is_active)"
              dark
              >{{ item.is_active ? "Active" : "Archived" }}</v-chip
            >
          </template>
          <template v-slot:item.occupancy_label="{ item }">
            <v-chip
              :x-small="true"
              class="ma-1"
              label
              :color="getOccupancyColor(item.occupancy_status)"
              text-color="white"
            >
              {{ item.occupancy_label || 'Available' }}
            </v-chip>
          </template>
          <template v-slot:item.waiter_name="{ item }">
            {{ item.waiter_name || '—' }}
          </template>
          <template v-slot:item.order_number="{ item }">
            {{ item.order_number || '—' }}
          </template>
          <template v-slot:item.image="{ item }">
            <v-avatar size="32px" item color="primary">
              <img
                v-if="item.image"
                height="30"
                width="30"
                :src="item.image"
                style="border-radius: 30%"
              />
              <span v-else class="white--text subtitle-2 text-uppercase">{{
                item.name.substring(0, 2)
              }}</span>
            </v-avatar>
          </template>

          <template v-slot:item.parentCatgory="{ item }">
            <!-- <img :src="item.image" /> -->
            {{ item.parent ? item.parent.name : "" }}
          </template>

          <!-- Action -->
          <template v-slot:item.action="{ item }">
            <list-menu
              feature="table"
              :item="item"
              editPermission="Table Edit"
              softDeletePermission="Table Soft Delete"
              DeletePermission="Table Soft Delete"
              @refreshList="refreshData"
              @onEditClicked="EditModal(item)"
              :isEditModal="true"
              :isSubViewModal="true"
              @onSubViewClicked="ViewCategory(item)"
            ></list-menu>
          </template>
          <template v-slot:footer>
            <pagination
              url="hms/tables"
              @paginationOptions="setPaginationOptions"
              @response="receiveCategoryData"
              :filter="filter"
              ref="pagination"
            />
          </template>
        </v-data-table>

        <!-- <v-row>
        <v-col cols="12 pa-5" align-self="end">
          <v-container class="max-width"></v-container>
        </v-col>
      </v-row> -->
        <!-- {{existImage}} -->
        <TableEditForm
        
          ref="editTable"
          :Table="selectedTable"
          @afterSave="refreshData()"
          @close="EditCategory($event)"
        />
         <TableCreateForm
            ref="createTable"
            @close="AddCategory($event)"
            @afterSave="refreshData()"
          />
      </v-card>
    </v-container>
  </div>
</template>

<script>
import TableFilters from "@/components/base/TableFilters";
import TableCreateForm from './TableCreate';
import { required, email, max } from "vee-validate/dist/rules";
import pagination from "../../../../shared/components/pagination";
import axios from "@/plugins/axios";
import FileUpload from "@/components/base/FileUpload";
import confirmation from '../../../../shared/components/confirmation';
import TableEditForm from "./TableEdit";
import _ from "lodash";
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from "vee-validate";
extend("required", {
  ...required,
  message: "{_field_} is required",
});

extend("max", {
  ...max,
  message: "{_field_} may not be greater than {length} characters",
});

extend("email", {
  ...email,
  message: "Email must be valid",
});

export default {
  data: () => ({
    paginationOptions: {},
    isCategoryFormVisible: false,
    selectedTable:Object(),
    pagination1: {
      descending: true,
      page: 1,
      rowsPerPage: 2,
      sortBy: "fat",
      totalItems: 0,
      rowsPerPageItems: [1, 2, 4, 8, 16],
    },
    pagination: {
      page: 1,
      itemsPerPage: 2,
    },
    page: 1,
    status: [
      { text: "Active", value: "active" },
      { text: "Archived", value: "archived" },
    ],
    columns: [
     
      {
        text: "Name",
        value: "name",
        show: true,
        disabled: false,
        width: "16.5%",
      },
         {
        text: "Type",
        value: "type",
        show: true,
        disabled: false,
        width: "16.5%",
      },
      {
        text: "Capacity",
        value: "capacity",
        show: true,
        disabled: false,
        width: "12%",
      },
      {
        text: "Live Status",
        value: "occupancy_label",
        show: true,
        disabled: false,
        width: "14%",
      },
      {
        text: "Waiter",
        value: "waiter_name",
        show: true,
        disabled: false,
        width: "14%",
      },
      {
        text: "Order #",
        value: "order_number",
        show: true,
        disabled: false,
        width: "12%",
      },
   
      {
        text: "Status",
        value: "is_active",
        show: true,
        disabled: false,
        align: "center",
        width: "10%",
      },
      {
        text: "Actions",
        value: "action",
        show: true,
        disabled: false,
        align: "center",
        width: "16.5%",
      },
    ],
    ProductCategory: [],
    // newbrand: { name: "", id: "", is_active: "" },
    filter: {
      name: "",
      search: "",
      status: "",
    },
  }),
  computed: {
    // Filter - return selected table fields
    headers: function () {
      return this.columns.filter((item) => item.show == true);
    },
  },

  components: {
    ValidationProvider,
    ValidationObserver,
    TableCreateForm,
    pagination,
    TableEditForm,
    FileUpload,
    TableFilters,
  },

  methods: {
    ViewCategory(item) {
      this.$router.push(`/masterdata/category/${item.id}`);
    },
    setPaginationOptions(data) {
      this.paginationOptions = data;
    },
    clearFilter() {
      this.filter = {};
    },
    navigate(item) {
      console.log(item);
    },

    OpenModal() {
        
      this.$refs.createTable.OpenModal()
    },

    receiveCategoryData(data) {
      this.ProductCategory = data;
    },
    refreshData() {
      this.$refs.pagination.refreshData();
    },

    AddCategory($event) {
      this.isCategoryFormVisible = false;
    },
    EditModal(data) {
      
      this.GetTableSigle(data.id);
      this.$refs.editTable.OpenModal();
      // this.editProductCategory = _.cloneDeep(data);
    },
    EditCategory($event) {
      this.EditScheduleForm = false;
      // this.editProductCategory={}
    },
    GetTableSigle(id) {
       axios
        .get(`hms/tables/${id}`)
        .then(async (res) => {
         this.selectedTable=res.data;

        })
          .catch(() => {
             
       
         })
  

    },
    getStatusColor(status) {
      return status ? "green" : "gray";
    },
    getOccupancyColor(status) {
      switch (status) {
        case "occupied":
          return "orange darken-2";
        case "held":
          return "blue darken-1";
        case "merged":
          return "deep-purple darken-1";
        default:
          return "green darken-1";
      }
    },
  },
  created() {
    this.refreshData();
  },
};
</script>
